import { Component, Input } from "@angular/core";
import { AuthService } from "../../services/auth/auth.service";
import { NzAlertModule } from "ng-zorro-antd/alert";

@Component({
    selector: 'app-unauthorized-access-edit-warning',
    standalone: true,
    imports: [
        NzAlertModule
    ],
    templateUrl: './unauthorized-access-edit-warning.component.html',
    styleUrls: ['./unauthorized-access-edit-warning.component.scss']
})
export class UnauthorizedAccessEditWarningComponent {
    @Input() warning?: string;
}
